'use strict';

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

document.addEventListener('DOMContentLoaded', function () {
    //---------------------------------------------------------------------------------------------------------------------
    // ft_Popover is an extension of Bootstrap's popover, which changes the behavior of click based popovers to dismiss
    // on clicks anywhere in the document (besides the actual popover)
    // It also adds the ability to add a custom css class to the popover via 'cssClass' option
    //
    var ft_Popover = function ft_Popover(element, options) {
        this.init('popover', element, options);
    };

    ft_Popover.prototype = $.extend({}, $.fn.popover.Constructor.prototype, {
        constructor: ft_Popover,

        toggle: function toggle(e) {
            // call base
            $.fn.bs_popover.Constructor.prototype.toggle.apply(this, arguments);

            // if we aren't click based do nothing
            if (!e || this.options.trigger !== 'click') return this;

            e.preventDefault();
            // add a marker to the element indicating that the popover is being shown.
            // we look for this marker in doc_onclick and don't dismiss
            $(e.target).data('ftpopover', this);

            return this;
        },

        show: function show() {
            var self = this;

            // add our css class
            if (this.options.cssClass) this.tip().addClass(this.options.cssClass);

            // call base class
            $.fn.bs_popover.Constructor.prototype.show.apply(this, arguments);

            // if we aren't click based do nothing
            if (this.options.trigger !== 'click' || !this.$tip) return this;

            this._document_onclick = function (e) {
                if ($(e.target).data('ftpopover') === self) $(e.target).removeData('ftpopover');else self.hide();
            };

            $(document).bind('click', this._document_onclick);
            this.$tip.click(function (e) {
                e.stopPropagation();
            });

            return this;
        },

        hide: function hide() {
            // call base class
            $.fn.bs_popover.Constructor.prototype.hide.apply(this, arguments);
            // if we aren't click based do nothing
            if (this.options.trigger !== 'click') return this;

            if (this._document_onclick) $(document).unbind('click', this._document_onclick);

            this._document_onclick = null;

            return this;
        }
    });

    (function ($) {
        // redefine the jquery popover plugin to create a ft_Popover
        $.fn.bs_popover = $.fn.popover;

        var dataName = '';
        var popoverVersion = $.fn.bs_popover.Constructor.VERSION;
        if (popoverVersion === undefined) {
            dataName = 'popover';
        } else if (popoverVersion.indexOf('3.2') === 0) {
            dataName = 'bs.popover';
        } else if (popoverVersion.indexOf('4.0.0') === 0 || popoverVersion.indexOf('5.3.3') === 0) {
            return;
        } else {
            throw new Error('Rev popover requires Boostrap 2, 3.2, 4.0.0 or 5.3.3');
        }

        $.fn.popover = function (option) {
            return this.each(function () {
                var $this = $(this);
                var data = $this.data(dataName);
                var options = (typeof option === 'undefined' ? 'undefined' : _typeof(option)) == 'object' && option;

                if (!data && option === 'destroy') return;
                if (!data) $this.data(dataName, data = new ft_Popover(this, options));
                if (typeof option === 'string') data[option]();
            });
        };

        $.extend($.fn.popover, $.fn.bs_popover);

        $.fn.popover.Constructor = ft_Popover;
    })(jQuery);

    // Exports
    window.ft_Popover = ft_Popover;
});